<div
  class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center"
  style="background-image: url('/login_background1.jpg')"
>
  <div class="pointer-events-none absolute inset-0 bg-slate-900/72"></div>

  <div class="relative z-10 flex w-full flex-col items-center px-4">
    <img class="mb-8 h-10 w-auto" src="/Aksia_Logo_white.png" alt="Aksia" />

    @if (!submitted()) {
      <form (submit)="requestReset($event)" novalidate>
        <div
          class="flex rounded-lg overflow-hidden"
          style="transition: box-shadow 200ms ease"
          [style.boxShadow]="
            showUsernameError()
              ? '0 4px 24px rgba(0,0,0,0.4), 0 0 0 1.5px #c0392b'
              : '0 4px 24px rgba(0,0,0,0.4)'
          "
          [class.form-shake]="formShaking()"
        >
          <input
            class="w-60 border-0 bg-white/95 px-3 py-2.5 text-sm text-slate-900 outline-none placeholder:text-slate-400"
            type="text"
            autocomplete="username"
            placeholder="Username"
            maxlength="32"
            [value]="username()"
            (input)="updateUsername($any($event.target).value)"
            (blur)="usernameTouched.set(true)"
          />
          <button
            class="border-l border-slate-200 bg-slate-100/95 px-5 text-sm font-medium text-slate-700 whitespace-nowrap transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
            type="submit"
            [disabled]="inFlight()"
          >
            @if (inFlight()) {
              <span
                class="block h-4 w-4 animate-spin rounded-full border-2 border-slate-400/30 border-t-slate-600"
              ></span>
            } @else {
              Send
            }
          </button>
        </div>

        @if (showUsernameError()) {
          <p class="mt-2 text-center text-xs text-rose-300">
            Please enter your username.
          </p>
        }

        <div
          class="mt-3 flex items-center justify-between text-xs text-white/75"
        >
          <button
            type="button"
            class="transition hover:text-white"
            (click)="goToLogin()"
          >
            Back to sign in
          </button>
          <a
            class="transition hover:text-white"
            href="mailto:support@aksia.com"
          >
            Contact support
          </a>
        </div>
      </form>
    } @else {
      <p class="max-w-xs text-center text-sm text-white/80">
        If an account exists for
        <span class="font-medium text-white">{{ username() }}</span
        >, reset instructions will arrive shortly.
      </p>
      <div class="mt-5">
        <button
          type="button"
          class="text-xs text-white/75 transition hover:text-white"
          (click)="goToLogin()"
        >
          Back to sign in
        </button>
      </div>
    }
  </div>

  <footer
    class="absolute bottom-0 w-full py-4 text-center text-xs text-white/40"
  >
    <a class="transition hover:text-white/70" href="mailto:support@aksia.com">
      Contact support
    </a>
  </footer>
</div>
